import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';




export default function AccountSettingSidebar() {

  const { t, i18n } = useTranslation();
  const location = useLocation();
  console.log("location", location);
  return (
    <div className="nested-menu">
      <div className="menu-title">
        <p> {t('settings.general')}</p>
      </div>
      <div className="menu-items">
        <ul>
          <li>
            <Link to="/admin/settings/profile" className={location.pathname.includes("/profile") ? "active" : ""}>
            {t('settings.account_settings.heading')}
            </Link>
          </li>
          {window.modulePermissions?.M9?.view == 1 && (
          <li>
            <Link to="/admin/settings/security" className={location.pathname.includes("/settings/security") ? "active" : ""}>
            {t('settings.security')}
            </Link>
          </li>
          )}
          {window.modulePermissions?.M10?.view == 1 && (
          <li>
            <Link to="/admin/settings/ticket-notifications" className={location.pathname.includes("/settings/ticket-notifications") ? "active" : ""}>
            {t('settings.ticket_notifications')}
            </Link>
          </li>
          )}
          {/* <li>
                        <Link to="/admin/settings/notification">Notifications</Link>
                    </li> */}

                     {/* <li>
            <Link to="/admin/settings/activity-log-template" className={location.pathname.includes("/activity-log-template") ? "active" : ""}>
            Activity logs template
            </Link>
          </li> */}
        </ul>
      </div>
      {(window.modulePermissions.M3.view == 1 || window.modulePermissions.M4.view == 1 || window.modulePermissions.M5.view==1) && (
        <>
      <div className="menu-title">
        <p>{t('settings.users_and_teams.heading')}</p>
      </div>
      <div className="menu-items">
        <ul>
          {window.modulePermissions.M3.view == 1 && (
          <li>
            <Link to="/admin/settings/user-permissions" className={location.pathname.includes("/settings/user-permissions") ? "active" : ""}>{t('settings.users_and_teams.users.heading')}</Link>
          </li>
          )}
          {window.modulePermissions.M4.view == 1 && (
          <li>
            <Link to="/admin/settings/user-roles" className={location.pathname.includes("/settings/user-roles") ? "active" : ""}>{t('settings.roles.heading')}</Link>
          </li>
          )}
          {window.modulePermissions.M5.view == 1 && (
          <li>
            <Link to="/admin/settings/teams/list" className={location.pathname.includes("/settings/teams/list") ? "active" : ""}>{t('settings.team.heading')}</Link>
          </li>
          )}
        </ul>
      </div>
      </>
      )}
      {window.modulePermissions?.M8?.view == 1 && (
      <>
      <div className="menu-title">
        <p>{t('settings.organization_details.heading')}</p>
      </div>
      <div className="menu-items">
        <ul>
          <li>
            <Link to="/admin/settings/organization-details/privacy-policy" className={location.pathname.includes("/organization-details/privacy-policy") ? "active" : ""}>
            {t('settings.organization_details.privacy_policy')}
            </Link>
          </li>
          <li>
            <Link to="/admin/settings/organization-details/terms-of-use" className={location.pathname.includes("/organization-details/terms-of-use") ? "active" : ""}>
            {t('settings.organization_details.terms_of_use')}
            </Link>
          </li>
          <li>
            <Link to="/admin/settings/organization-details/cookie-policy" className={location.pathname.includes("/organization-details/cookie-policy") ? "active" : ""}>
            {t('settings.organization_details.cookie_policy')}
            </Link>
          </li>
        </ul>
      </div>
      </>
      )}
    </div>
  );
}
